import React, {Component} from "react";
import Owner from "../models/Owner";
import { Trans } from 'react-i18next'

export default class MenuBar extends Component {
  readonly owner = Owner.instance;

  animateLanguagesLevel() {
    let bar
    this.owner.languages.forEach((lang, i) => {
      // @ts-ignore
      bar = new ProgressBar.Circle(`#circleprog${i + 1}`, {
        strokeWidth: 7,
        easing: 'easeInOut',
        duration: 1400,
        delay: 2500,
        trailWidth: 7,
        // @ts-ignore
        step: function(state, circle) {
          var value = Math.round(circle.value() * 100);
          if (value === 0) {
            circle.setText('');
          } else {
            circle.setText(value);
          }
        }
      });

      bar.animate(lang.level / 100)
    })
  }

  animateHardSkillsLevel() {
    let bar
    this.owner.skills.forEach((skill, i) => {
      // @ts-ignore
      bar = new ProgressBar.Line(`#lineprog${i + 1}`, {
        strokeWidth: 1.72,
        easing: 'easeInOut',
        duration: 1400,
        delay: 2900,
        trailWidth: 1.72,
        svgStyle: {
          width: '100%',
          height: '100%'
        },
        // @ts-ignore
        step: (state, bar) => {
          bar.setText(Math.round(bar.value() * 100) + ' %');
        }
      })

      bar.animate(skill.level / 100)
    })
  }

  componentDidMount(): void {
    this.animateLanguagesLevel()
    this.animateHardSkillsLevel()
  }

  render() {
    return (
      <div className="art-info-bar-frame">

        {/* info bar header */}
        <div className="art-info-bar-header">
          {/* info bar button */}
          <a className="art-info-bar-btn" href="#.">
            {/* icon */}
            <i className="fas fa-ellipsis-v"/>
          </a>
          {/* info bar button end */}
        </div>
        {/* info bar header end */}

        {/* info bar header */}
        <div className="art-header">
          {/* avatar */}
          <div className="art-avatar">
            <a data-fancybox="avatar" href="img/face-1.jpg" className="art-avatar-curtain">
              <img src="img/face-1.jpg" alt="avatar" />
              <i className="fas fa-expand"/>
            </a>
            {/* available */}
            <div className="art-lamp-light">
              {/* add class 'art-not-available' if not available */}
              <div className="art-available-lamp"/>
            </div>
          </div>
          {/* avatar end */}
          {/* name */}
          <h5 className="art-name mb-10"><a href="home.html">{ this.owner.fullName }</a></h5>
          {/* post */}
          <div className="art-sm-text">
            {
              this.owner.jobTitles.map((job, i) => (
                <React.Fragment key={i}>
                  {job} {i === this.owner.jobTitles.length - 1 ? ',' : ''}<br/>
                </React.Fragment>
              ))
            }
          </div>
        </div>
        {/* info bar header end */}

        {/* scroll frame */}
        <div id="scrollbar2" className="art-scroll-frame">

          {/* info bar about */}
          <div className="art-table p-15-15">
            {/* about text */}
            <ul>
              {/* country */}
              <li>
                <h6>Residence:</h6><span>{this.owner.residenceCountry}</span>
              </li>
              {/* city */}
              <li>
                <h6>City:</h6><span>{this.owner.city}</span>
              </li>
              {/* age */}
              <li>
                <h6>Age:</h6><span>{this.owner.age}</span>
              </li>
            </ul>
          </div>
          {/* info bar about end */}

          {/* divider */}
          <div className="art-ls-divider" />

          {/* language skills */}
          <div className="art-lang-skills p-30-15">

            {/* skill */}
            {
              this.owner.languages.map((lang, i) => (
                <div className="art-lang-skills-item" key={i}>
                  <div id={`circleprog${i + 1}`} className="art-cirkle-progress" />
                  {/* title */}
                  <h6>{lang.name}</h6>
                </div>
              ))
            }
            {/* skill end */}
          </div>
          {/* language skills end */}

          {/* divider */}
          <div className="art-ls-divider"/>

          {/* hard skills */}
          <div className="art-hard-skills p-30-15">

            {/* skill */}
            {
              this.owner.skills.map((skill, i) => (
                <div className="art-hard-skills-item" key={i}>
                  <div className="art-skill-heading">
                    {/* title */}
                    <h6>{skill.name}</h6>
                  </div>
                  {/* progressbar frame */}
                  <div className="art-line-progress">
                    {/* progressbar */}
                    <div id={`lineprog${i + 1}`}/>
                  </div>
                  {/* progressbar frame end */}
                </div>
              ))
            }
            {/* skill end */}
          </div>
          {/* language skills end */}

          {/* divider */}
          <div className="art-ls-divider"/>

          {/* knowledge list */}
          <ul className="art-knowledge-list p-15-0">
            {/* list item */}
            {
              this.owner.secondarySkills.map((skill, i) => <li key={i}>{skill.name}</li>)
            }
          </ul>
          {/* knowledge list end */}

          {/* divider */}
          <div className="art-ls-divider"/>

          {/* links frame */}
          <div className="art-links-frame p-15-15">

            {/* download cv button */}
            <a href={this.owner.cvUrl} className="art-link" download target='_blank' rel="noopener noreferrer">
              <Trans>commons.labels.downloadCv</Trans> <i className="fas fa-download"/>
            </a>

          </div>

          <div className="art-links-frame p-15-15">

            {/* download cv button */}
            <a href={this.owner.githubRepoUrl} className="art-link" target='_blank' rel="noopener noreferrer">
              <Trans>commons.labels.githubRepo</Trans> <i className="fas fa-eye"/>
            </a>

          </div>
          {/* links frame end */}

        </div>
        {/* scroll frame end */}

        {/* sidebar social */}
        <div className="art-ls-social">
          {/* social link */}
          {
            this.owner.socialMedias.map(social => (
              <a href={social.link} target="_blank" key={social.name} rel='noopener noreferrer'>
                <i className={social.icon}/>
              </a>
            ))
          }
        </div>
        {/* sidebar social end */}

      </div>
    );
  }
}
